import resume from "./docs/TonnyMakondesa.pdf";

const Footer = ({Links}) => {

    let Logos = [
        {logo:<ion-icon name="logo-github"></ion-icon>, userName:"GitHub", link:"https://github.com/Tonny2wo6ix5ive"},
        {logo:<ion-icon name="logo-twitter"></ion-icon>, userName:"Twitter", link:"https://twitter.com/Tonny2wo6ix5ive"},
        {logo:<ion-icon name="logo-instagram"></ion-icon>, userName:"Instagram", link:"https://www.instagram.com/tonny2wo6ix5ive"},
        {logo:<ion-icon name="logo-facebook"></ion-icon>, userName:"FaceBook", link:"https://web.facebook.com/tonny.makondesa"},
        {logo:<ion-icon name="logo-linkedin"></ion-icon>, userName:"LinkedIn", link:"https://www.linkedin.com/in/tonny-makondesa/"}
    ]

    const year = new Date();

    return ( 
        <footer class="text-slate-400 bg-black h-16 ">
              <hr class=""/>
              <div class="flex justify-center my-6">
                  <div class="text-sm font-semibold">
                    &#169; Tonny Makondesa <span id="get-current-year">{year.getFullYear()}</span>
                  </div>
              </div>
        </footer>
     );
}
 
export default Footer;